// extracted by mini-css-extract-plugin
export default {"header":"Header_header__stqK6","logoLink":"Header_logoLink__pJtLN"};